import { type InstallableApp } from "~/pwa/installableApps";
import rootInstallApp from "~/pwa/rootInstallApp";

interface InstallTargetInput {
	enabledByKey: Partial<Record<string, boolean>>;
	rootInstalled: boolean;
}

const resolveInstallTargets = ({ enabledByKey, rootInstalled }: InstallTargetInput): InstallableApp[] => {
	const hasEnabledModule = Object.values(enabledByKey).some((enabled) => enabled === true);
	return hasEnabledModule && !rootInstalled ? [rootInstallApp] : [];
};

export type { InstallTargetInput };
export default resolveInstallTargets;
